import { BaseModel } from '../base-model'

export interface PortalQuestion extends BaseModel {
  content: string
  type: PORTAL_QUESTION_TYPE
  status: PORTAL_QUESTION_STATUS
  answers?: string[]
  portalIds: string[]
  procedureCodes: string[]
  diagnosesCodes?: string[]
}

export enum PORTAL_QUESTION_STATUS {
  ACTIVE = 'active',
  DISABLED = 'disabled',
}

export enum PORTAL_QUESTION_TYPE {
  TEXT = 'text',
  SELECT = 'select',
  MULTISELECT = 'multi-select',
  BOOLEAN = 'boolean',
}
